import template from './spinner.html';

export const SpinnerModule = angular
    .module('app.components.spinner', [])
    .component('spinner', {
        template
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/spinner/spinner.module.js